import React from "react";
import { connect } from "react-redux";

import { faExternalLinkAlt } from "@fortawesome/pro-solid-svg-icons/faExternalLinkAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col } from "antd/es/grid";
import Row from "antd/es/row";
import { useIntl } from "react-intl";

import { Modal } from "@mapmycustomers/ui";

import point1 from "@app/assets/email/info-modal-point1.svg";
import point2 from "@app/assets/email/info-modal-point2.svg";
import point3 from "@app/assets/email/info-modal-point3.svg";
import point4 from "@app/assets/email/info-modal-point4.svg";
import Path from "@app/enum/Path";
import { isEmailFeaturesVisible } from "@app/store/email";
import { hideEmailFeatures } from "@app/store/email/actions";
import { RootState } from "@app/store/rootReducer";

import ButtonLink from "../../ButtonLink";
import EmailQuotaInfo from "../EmailQuotaInfo";

import styles from "./EmailFeaturesModal.module.scss";
import messages from "./messages";

const EmailFeaturesModal = ({
  onEmailFeaturesHide,
  visible,
}: ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
  const intl = useIntl();

  if (!visible) {
    return null;
  }

  return (
    <Modal
      cancelButtonProps={{ hidden: true }}
      className={styles.container}
      okText={intl.formatMessage(messages.featuresOk)}
      onCancel={() => onEmailFeaturesHide()}
      onOk={() => onEmailFeaturesHide()}
      open
      title={intl.formatMessage(messages.featuresTitle)}
      wrapClassName={styles.modalWrapper}
    >
      <Row>
        <Col span={2}>
          <img alt="point-1" src={point1} />
        </Col>
        <Col span={21}>
          <div className={styles.point}>{intl.formatMessage(messages.featuresPoint1Title)}</div>
          <div className={styles.description}>
            {intl.formatMessage(messages.featuresPoint1Description)}
          </div>
          <EmailQuotaInfo />
        </Col>
      </Row>
      <Row>
        <Col span={2}>
          <img alt="point-2" src={point2} />
        </Col>
        <Col span={21}>
          <div className={styles.point}>{intl.formatMessage(messages.featuresPoint2Title)}</div>
          <div className={styles.description}>
            {intl.formatMessage(messages.featuresPoint2Description, { br: <br /> })}
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={2}>
          <img alt="point-3" src={point3} />
        </Col>
        <Col span={21}>
          <div className={styles.point}>{intl.formatMessage(messages.featuresPoint3Title)}</div>
          <div className={styles.description}>
            {intl.formatMessage(messages.featuresPoint3Description)}
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={2}>
          <img alt="point-3" src={point4} />
        </Col>
        <Col span={21}>
          <div className={styles.point}>{intl.formatMessage(messages.featuresPoint4Title)}</div>
          <div className={styles.description}>
            {intl.formatMessage(messages.featuresPoint4Description2)}
          </div>
          <ButtonLink
            className={styles.link}
            href={`${window.location.origin}${Path.EMAIL_OUTBOX}`}
          >
            <FontAwesomeIcon icon={faExternalLinkAlt} />
            {intl.formatMessage(messages.openEmailOutbox)}
          </ButtonLink>
        </Col>
      </Row>
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  visible: isEmailFeaturesVisible(state),
});

const mapDispatchToProps = {
  onEmailFeaturesHide: hideEmailFeatures,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailFeaturesModal);
